<template>
  <div id="userLayout" :class="['user-layout-wrapper']">
    <router-view />
  </div>
</template>

<script setup>
defineOptions({
  name: "UserLayout"
});
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  background: #f5f5f7;

  .container {
    width: 100%;
    min-height: 100%;
    background: #f5f5f7;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .user-layout-lang {
      width: 100%;
      height: 40px;
      line-height: 44px;
      text-align: right;
      position: absolute;
      top: 0;

      .select-lang-trigger {
        cursor: pointer;
        padding: 12px;
        margin-right: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .user-layout-content {
      padding: 40px;

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 28px;
            color: #1d1d1f;
            font-family:
              "Inter",
              -apple-system,
              BlinkMacSystemFont,
              "Segoe UI",
              Roboto,
              sans-serif;
            font-weight: 700;
            position: relative;
            top: 2px;
            letter-spacing: -0.5px;
          }
        }
        .desc {
          font-size: 15px;
          color: #6e6e73;
          margin-top: 8px;
          margin-bottom: 36px;
          font-weight: 400;
        }
      }

      .main {
        min-width: 260px;
        width: 400px;
        margin: 0 auto;
        background: #fff;
        border: 1px solid #e5e5e7;
        border-radius: 28px;
        padding: 48px 40px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
      }

      .footer {
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: #6e6e73;
            transition: all 0.2s;
            &:not(:last-child) {
              margin-right: 40px;
            }
            &:hover {
              color: #1d1d1f;
            }
          }
        }
        .copyright {
          color: #86868b;
          font-size: 14px;
        }
      }
    }

    a {
      text-decoration: none;
    }
  }
}
</style>
